import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import { Tab, Tabs } from "@nextui-org/react";

import useGetOrgFramework from "../../hooks/useGetOrgFramework";
import SingleFrameworkTable from "./SingleFrameworkTable";
import LoadingPage from "../../components/Loader/LoadingPage";
import useGetDefaultOrg from "../../hooks/useGetDefaultOrg";
import { StandardCreateButton } from "../../components/StandardButtons";

/**
 * BrowseFramework Component
 * Main page for browsing and managing organization frameworks
 * Displays frameworks in tabs with individual framework tables
 * @returns {JSX.Element} Framework browsing interface
 */
const BrowseFramework = () => {
  // User and organization information from session storage
  const userLogged = JSON.parse(sessionStorage.getItem("userData"));
  const orgInfo = userLogged && userLogged.user.LastOrgId;

  // Custom hooks for organization and framework data
  const { OrgDetail: defaultOrgDetail } = useGetDefaultOrg();
  const { orgFrameworkDetails: frameworkList, isLoading } =
    useGetOrgFramework(orgInfo);

  // Navigation and routing
  const navigate = useNavigate();
  const { _orgId: currentOrgId } = useParams();

  // Organization filter URL for API calls
  const orgFilterUrl = "filters[organizations][id][$eqi]=" + orgInfo;

  /**
   * Navigate to framework creation page
   * Only available for default organization users
   */
  const handleCreateNavigate = () => {
    navigate(`/${currentOrgId}/browse-framework/create`);
  };

  return (
    <BreadCrumbsPage>
      {/* Page Header */}
      <div>
        <div className="flex items-center justify-between text-3xl font-medium">
          <span>Browse Frameworks</span>
          {/* 
            TODO: Re-enable create framework button when needed
            Currently commented out to prevent unauthorized framework creation
            
            {defaultOrgDetail?.id === orgInfo && (
              <StandardCreateButton size="sm" onClick={handleCreateNavigate}>
                + Create your own framework
              </StandardCreateButton>
            )}
          */}
        </div>
        <div className="mt-8">
          Browse frameworks to manage your reporting.
        </div>
      </div>
      
      {/* Framework Tabs Section */}
      <div className="mt-4">
        <LoadingPage isLoading={isLoading} loadingText="Loading frameworks...">
          <Tabs variant="light">
            {/* Render each framework as a separate tab */}
            {frameworkList?.map((framework, index) => {
              return (
                <Tab key={index} title={framework?.attributes?.Name || "Others"}>
                  <SingleFrameworkTable
                    data={framework}
                    frameworkName={framework?.attributes?.Name}
                  />
                </Tab>
              );
            })}
          </Tabs>
        </LoadingPage>
      </div>
    </BreadCrumbsPage>
  );
};

export default BrowseFramework;
